import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';

const ThemeContext = createContext({ theme: 'dark', setTheme: () => {}, toggle: () => {} });

const STORAGE_KEY = 'aga.theme';

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) || 'dark';
    } catch (e) {
      // localStorage may be disabled (private mode / strict cookie blockers).
      console.debug('Theme read from localStorage failed:', e?.message || e);
      return 'dark';
    }
  });

  useEffect(() => {
    const root = document.documentElement;
    root.classList.remove('theme-dark', 'theme-light');
    root.classList.add(theme === 'light' ? 'theme-light' : 'theme-dark');
    try { localStorage.setItem(STORAGE_KEY, theme); }
    catch (e) { console.debug('Theme persist failed:', e?.message || e); }
  }, [theme]);

  const toggle = () => setTheme((t) => (t === 'light' ? 'dark' : 'light'));

  // Memoize the context value so consumers that depend only on `theme` don't
  // re-render when an unrelated state change re-renders this provider.
  const value = useMemo(() => ({ theme, setTheme, toggle }), [theme]);

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  );
}

export const useTheme = () => useContext(ThemeContext);
